export const name = 'imagePlaceholderService' as const
